<template>
  <div class="riddle__progress" :style="`--progress: ${progress}%`">
    <AvatarFull tiny />
    <div class="riddle__progress-bar" />
    <Image :source="$beet.options.hunt.cauldron" class="riddle__progress-goal" />
  </div>
</template>

<script>
import { AvatarFull } from '@/components/avatar'
import { Image } from '@/components/global'

export default {
  name: 'RiddleProgress',
  components: { AvatarFull, Image },
  computed: {
    progress() {
      return (
        ((this.$store.state.hunter.completed_riddles_count + 1) /
          (this.$store.state.riddle.count + 1)) *
        84
      )
    },
  },
}
</script>
